// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1A754","logo":"MainNavigation_logo__3yNPP","nav":"MainNavigation_nav__J64c-","active":"MainNavigation_active__1Ry5U"};